/**
 * The online form reuses the signing page's .template-main-container but its content is fluid,
 * so the fixed 810px page's scale and height writes must not run on it.
 */
export function isFluidEFormContainer(container: Element): boolean {
    return container.closest('.online-eform-wrapper') !== null;
}
